import React, { useState } from "react";
import {PaymentElement} from "@stripe/react-stripe-js";
import BackButton from "../../common/buttons/BackButton";
import SyncLoader from "react-spinners/SyncLoader";
import {PAYMENT_METHOD_PAGES} from "../../../constants";

export const NewPaymentMethodSection = (props: {stripe:Object, elements: Object, loading: Boolean, setLoading: Function,
                                      onBack: Function, setShouldRefresh: Function, setPage:Function}) => {
    const {
        stripe, elements, loading,
        setLoading, onBack, setShouldRefresh, setPage
    } = props;

    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault(); // Prevent default form submission.
        if (!stripe || !elements || !submitting) {
            return;
        }

        setLoading(true);

        const options = {
            //`Elements` instance that was used to create the Payment Element
            elements,
            confirmParams: {
                return_url: window.location.toString(),
            },
            redirect: 'if_required',
        };

        const result = await stripe.confirmSetup(options);
        const { error, setupIntent } = result;

        if (error) {
            setLoading(false);
            setError(error.message);
            return;
        }

        if (setupIntent) {
            stripe.retrieveSetupIntent(setupIntent.client_secret).then(() => {
                setLoading(false);
                setPage(PAYMENT_METHOD_PAGES.SPLASH)
                setShouldRefresh(val => !val);
            });
        }
    };

    const onBackBtnClick = () => {
        onBack();
    }

    return (
        <div className={'margin-top-1'} data-testid={'newPaymentMethodSectionDiv'}>
            <form onSubmit={handleSubmit}>
                <div>
                    <PaymentElement onReady={() => setLoading(false)}/>
                    <div className={"flexSpaceBetween footerMargins"}>
                        <BackButton onClick={onBackBtnClick}
                                    disabled={loading || !stripe || !elements}
                                    hidden={loading}/>
                        <button className={"button-pay"}
                                onClick={() => {setSubmitting(true)}}
                                disabled={loading || !stripe || !elements}
                                data-testid={'addNewPaymentMethodBtn'}
                                hidden={loading}>{i18n.payments.addNewPaymentMethod}</button>
                    </div>
                </div>
                {loading && (<div><SyncLoader /></div>)}
            </form>
        </div>
    );
}